import React, { useEffect, useState } from "react";
import { Header } from "build-ts/metadata";
import { ScenarioResultProto, ScenarioResultProto_ReferencedTreeNodes, ScenarioResultProto_ScenarioStatus, ScenariosProcessingOutput } from "build-ts/schedule";
import ReasoningTree from "components/agentChat/ReasoningTree";
import { AnalysisTreeNodeProto } from "build-ts/analysis";
import { ArtifactProto } from "build-ts/chat_session";


interface ReasoningTreeContainerProps {
	treeHeaders?: Header[] | undefined;
	scenarioResults?: ScenarioResultProto[];
	synthesisResult?: ScenariosProcessingOutput;
	contextualisationResult?: ScenariosProcessingOutput;
	nodeDataMap: Map<string, AnalysisTreeNodeProto | null>;
	setNodeDataMap: React.Dispatch<React.SetStateAction<Map<string, AnalysisTreeNodeProto | null>>>;
	onTableClick?: (nodeId: string) => void;
	onFindingsClick?: (scenarioId: number) => void;
	onSynthesisClick?: () => void;
	onContextualizationClick?: () => void;
	artifacts?: ArtifactProto[];
}

export interface ScenarioResult {
	id: number | undefined;
	issue?: string | undefined;
	referencedTreeNodes?: ScenarioResultProto_ReferencedTreeNodes[];
	status?: ScenarioResultProto_ScenarioStatus | undefined;
	findings?: string | undefined;
}

const ReasoningTreeContainer: React.FC<ReasoningTreeContainerProps> = ({ 
	scenarioResults, 
	synthesisResult, 
	contextualisationResult,
	nodeDataMap,
	setNodeDataMap,
	onTableClick,
	onFindingsClick,
	onSynthesisClick,
	onContextualizationClick,
	artifacts,
}) => {
	const [treeNodes, setTreeNodes] = useState<ScenarioResult[]>([]);

	// Design the tree nodes
	useEffect(() => {
		const buildTreeNodes = async () => {
			if(scenarioResults){
				const treeNodes : ScenarioResult[] = [];
				for(const scenarioResult of scenarioResults){
					treeNodes.push({
						id: scenarioResult.scenario_id,
						issue: scenarioResult.issue,
						referencedTreeNodes: scenarioResult.referenced_tree_nodes,
						status: scenarioResult.status,
						findings: scenarioResult.findings
					});
				}
				setTreeNodes(treeNodes);
			};
		};
		
		buildTreeNodes();
	},[scenarioResults, artifacts]);
	
  return (
    <ReasoningTree 
      treeNodes={treeNodes}
      nodeDataMap={nodeDataMap}
      synthesisResult={synthesisResult}
      contextualisationResult={contextualisationResult}
      onTableClick={onTableClick}
      onFindingsClick={onFindingsClick}
      onSynthesisClick={onSynthesisClick}
      onContextualizationClick={onContextualizationClick}
	    artifacts={artifacts}
    />
  );
};

export default ReasoningTreeContainer;